import { global } from "../constants";

export const data = {
    banner: {
        background: global.banner + "1.jpg",
        title: "Blogs/News",
        crumb: "Blog"
    },

    blogs: [
        {
            image: global.blog1 + "bg1.jpg",
            day: "02",
            month: "Jan",
            year: "2025",
            title: "How Source Huts is Revolutionizing Global Sourcing and Procurement",
            description: "Discover how Source Huts helps businesses streamline product sourcing with top manufacturers worldwide.",
            id:1
        },
        {
            image: global.blog2 + "l-1.jpg",
            day: "08",
            month: "Jan",
            year: "2025",
            title: "Why Quality Control is Key in Sourcing: A Source Huts Perspective",
            description: "At Source Huts, we prioritize quality assurance in every step of the sourcing process, ensuring client satisfaction.",
            id:2
        },
        {
            image: global.blog1 + "bg2.jpg",
            day: "21",
            month: "Jan",
            year: "2025",
            title: "How Product Sourcing is Evolving in the Global Market",
            description: "Explore the future of product sourcing and how Source Huts adapts to the dynamic global market trends.",
            id:3
        },
        {
            image: global.blog2 + "l-2.jpg",
            day: "02",
            month: "Feb",
            year: "2025",
            title: "The Role of Factory Audits in Ensuring Product Quality",
            description: "Learn how Source Huts conducts detailed factory audits to maintain high standards in manufacturing.",
            id:4
        },
        {
            image: global.blog1 + "bg3.jpg",
            day: "08",
            month: "Feb",
            year: "2025",
            title: "Inspection Services: Ensuring Products Meet Global Standards",
            description: "Source Huts offers comprehensive product inspection services to ensure compliance with international quality standards.",
            id:5
        },
        {
            image: global.blog2 + "l-3.jpg",
            day: "21",
            month: "Feb",
            year: "2025",
            title: "Photography and Videography: Capturing Your Products in the Best Light",
            description: "See how Source Huts enhances the visual appeal of your products through professional photography and videography.",
            id:6
        }
      
    ]
}
